module.exports = __webpack_public_path__ + "img/4pin.235453e8.png";